import React, {useEffect, useState} from "react";
import DragAction from "./dragAction/DragAction";
import {makeStyles, withStyles} from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import {useTranslation} from "react-i18next";
import {RepeatComp} from "../component/AutomComponent";
import Grid from "@material-ui/core/Grid";
import MaximizeIcon from "@material-ui/icons/Maximize";
import AddIcon from "@material-ui/icons/Add";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(() => ({
    root: {
        height: "90vh",
        background: "#FFFFFF",
        boxShadow: " 0px 0px 8px -3px rgba(0, 0, 0, 0.25)",
        borderRadius: "5px",
        margin: "37px 20px 20px 20px",
        //  overflowY: "scroll",
        paddingTop: "10px",
        overFlowX: "hidden !important"
    },
    heading: {
        fontSize: "12px",
        fontWeight: "bold",
        color: "#8C90A2",
    },
    headingActive: {
        fontSize: "12px",
        fontWeight: "bold",
        color: "#fff",
    }
}));
const useStylesSearch = makeStyles((theme) => ({
    root: {
        padding: "10px",
        display: "flex",
        alignItems: "center",
        background: "#FAFAFA",
        height: "2rem",
        margin: "0px 15px 20px 15px",

    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
        borderRadius: "2px",
        fontSize: "12px"
    },
    iconButton: {
        padding: 10,
    },
}));

const Accordion = withStyles({
    root: {
        boxShadow: "none",
        "&:not(:last-child)": {
            borderBottom: 0,
        },
        "&:before": {
            display: "none",
        },
        "&$expanded": {
            margin: "auto",
        },
    },
    expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        minHeight: "0 !important",
        height: "100%",
        "&$expanded": {
            minHeight: 56,
        },
    },
    content: {
        "&$expanded": {
            margin: "2px 0",
        },
        margin: 0,
    },
    expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiAccordionDetails);


function LibraryList({ data, libraryIndex, setExpandedMain, expandedMain }) {
    const [value, setValue] = useState("");
    const {t} = useTranslation();
    const [expandedAlt, setExpandedAlt] = useState(true);
    const classesSearch = useStylesSearch();
    const classes = useStyles();
    const [changeIcon, setChangeIcon] = useState(data?.module_name === "AUTOMS");

    const openLibraryMain = (id) => {
        if (expandedMain === libraryIndex) {
            setExpandedMain(-1);
        } else {
            setExpandedMain(id);
        }
        setChangeIcon(!changeIcon);

    };
    let filterSearch = data?.libraries && data.libraries.map((item) => {
        //filtered action name

        let newObj;
        if (item.actions) {
            let action = item.actions.filter((act) => {
                if (
                    t(`CONTENT.LIBRARY.${item.library_name}.ACTION.${act.action_name}`)
                        .toLowerCase()
                        .includes(value.toLowerCase())
                ) {
                    return t(
                        `CONTENT.LIBRARY.${item.library_name}.ACTION.${act.action_name}`
                    )
                        .toLowerCase()
                        .includes(value.toLowerCase());
                } else if (item.library_label.includes('CUSTOM') && item.library_label.toLowerCase().includes(value.toLowerCase())) {
                    return item.library_label
                }
            });
            let currentVersion = item && item.library_versions.filter(version => version.is_active)
            // when are filtered actions , edit actions
            let recorderFilter = ['FIND-AND-INPUT', 'HOVER', 'ELEMENT-EXIST', 'GET-TEXT', 'FIND-AND-CLICK', 'PAGINATION'];

            function editNewAction(datas) {
                return datas.map((actionI) => {
                    if (
                        actionI.flow_behavior.includes("groupable")
                    ) {
                        return {
                            ...actionI,
                            actionId: actionI.id,
                            type: "nested",
                            item: RepeatComp,
                            actionName: actionI.action_name,
                            accepts: actionI.action_name === "SCOPE" ? ["nested", "action", "recorder"] : ["nested", "action"],
                            source: true,
                            children: [],
                            acceptsNewChildren: true,
                            isDebugging: false,
                            order: 0,
                            image: item.image,
                            libraryName: item.library_name,
                            libraryLabel: item.library_label,
                            version: currentVersion[0]?.version,
                            versionId: currentVersion[0]?.id,
                            selected: false,
                            expandable: true,
                            main: false,
                        };
                    } else {
                        return {
                            ...actionI,
                            actionId: actionI.id,
                            item: "div",
                            type: recorderFilter.includes(actionI.action_name) ? "recorder" : "action",
                            actionName: actionI.action_name,
                            isDebugging: false,
                            accepts: [],
                            source: true,
                            children: [actionI.action_name],
                            acceptsNewChildren: false,
                            order: 0,
                            image: item.image,
                            libraryName: item.library_name,
                            libraryLabel: item.library_label,
                            version: currentVersion[0]?.version,
                            versionId: currentVersion[0]?.id,
                            selected: false,
                            expandable: true,
                            main: false,

                        };
                    }
                });
            }

            // create newObj
            if (action.length > 0) {
                let newActions = editNewAction(action);
                if (newActions.length > 0) {
                    newObj = {
                        id: item.id,
                        image: item.image,
                        library_name: item.library_name,
                        actions: newActions,
                        library_label: item.library_label,
                    };
                }
            }
            // only library name filter  and all actions
            else {
                if (
                    t("CONTENT.LIBRARY." + item.library_name + ".NAME")
                        .toLowerCase()
                        .includes(value.toLowerCase())
                    ||
                    (
                        item.library_label.includes('CUSTOM') && item.library_label.toLowerCase().includes(value.toLowerCase())
                    )

                ) {
                    let newActions = editNewAction(item.actions);
                    newObj = {
                        id: item.id,
                        image: item.image,
                        actions: newActions,
                        library_name: item.library_name,
                        library_label: item.library_label,
                    };
                }
            }
        }
        return newObj;
    });
    // clicked library after then opened action
    useEffect(() => {
        setExpandedAlt(true);
    }, []);
    const filtered = filterSearch.filter(function (el) {
        return el != null;
    });
    return (
        <Accordion
            id="accordion-panel"
            expanded={expandedMain === libraryIndex}
            TransitionProps={{unmountOnExit: true}}
        >
            <AccordionSummary
                onClick={() => openLibraryMain(libraryIndex)}
                expandIcon={
                    expandedMain === libraryIndex ? (
                        <MaximizeIcon style={{marginBottom: "-1rem", color: "#fff", height: "20px"}}/>
                    ) : (
                        <AddIcon/>
                    )
                }
                aria-controls="panel1a-content"
                style={{
                    margin: "0px 15px 5px 15px",
                    borderRadius: "2px",
                    height: "35px",
                    backgroundColor: (expandedMain === libraryIndex) ? "#46474E" : "#fff"
                }}
            >
                <Typography className={expandedMain === libraryIndex ? classes.headingActive : classes.heading}>
                    {t("CONTENT.AUTOMS-LIST." + data?.module_name)}
                </Typography>
            </AccordionSummary>
            <AccordionDetails id="accordion-panel-alt">
                <div className={classesSearch.root}>
                    <IconButton
                        type="submit"
                        className={classesSearch.iconButton}
                        aria-label="search"
                        id="search-icon"
                    >
                        <SearchIcon />
                    </IconButton>
                    <InputBase
                        className={classesSearch.input}
                        placeholder={t("CONTENT.FLOW.SEARCH")}
                        inputProps={{ "aria-label": value }}
                        onChange={(e) => setValue(e.target.value)}
                    />
                </div>
                <div className="left-side-scrollable">
                    {filtered.length > 0 ? (
                        filtered.map((action, index) => (
                            <div key={index}>
                                {index === 0 ? (
                                    <Accordion
                                        expanded={
                                            (value.length > 1 ? expandedAlt : !expandedAlt) ||
                                                index === 0
                                                ? expandedAlt
                                                : !expandedAlt
                                        }
                                        id="accordion-panel"
                                    >
                                        <AccordionSummary
                                            onClick={() => setExpandedAlt(!expandedAlt)}
                                            expandIcon={<ExpandMoreIcon style={{ fill: expandedAlt ? "#031226" : "" }} />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                            style={{ margin: "0px 15px 5px 15px", borderRadius: "2px", height: "35px", backgroundColor: expandedAlt ? "#D2E9FF" : "#fff" }}
                                        >
                                            <ul className={expandedAlt ? "left-side-list-header-active" : "left-side-list-header"}>
                                                <li>
                                                    {
                                                        action.library_label.includes('CUSTOM') ? action.library_label :
                                                            t(
                                                                "CONTENT.LIBRARY." + action.library_name + ".NAME"
                                                            )
                                                    }
                                                </li>
                                            </ul>
                                        </AccordionSummary>

                                        <Grid container spacing={1}>
                                            <Grid item xs={1}>
                                                <div className="vertical-seperator" />
                                            </Grid>
                                            <Grid item xs={11}>
                                                <DragAction info={action.actions} />
                                            </Grid>
                                        </Grid>

                                    </Accordion>
                                ) : (
                                    <Accordion id="accordion-panel">
                                        <AccordionSummary
                                            style={{ margin: "0px 15px 5px 15px", borderRadius: "2px", height: "35px", backgroundColor: "#fff" }}
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                        >
                                            <ul className="left-side-list-header">
                                                <li>
                                                    {t(
                                                        "CONTENT.LIBRARY." + action.library_name + ".NAME"
                                                    )}
                                                </li>
                                            </ul>
                                        </AccordionSummary>

                                        <Grid container spacing={1}>
                                            <Grid item xs={1}>
                                                <div className="vertical-seperator" />
                                            </Grid>
                                            <Grid item xs={11}>
                                                <DragAction info={action.actions} />
                                            </Grid>
                                        </Grid>

                                    </Accordion>
                                )}
                            </div>
                        ))
                    ) : (
                        <h3 style={{ marginLeft: "17px" }}>{t("MESSAGES.AUTOMS.AUTOMS-NOT-FOUND")}</h3>
                    )}
                </div>
            </AccordionDetails>
        </Accordion>
    );
}

export default LibraryList;
